import { Button } from "components/ui/Button";
import { Container } from "components/ui/Container";
import { InputGroup } from "components/ui/InputGroup";
import { SectionTitle } from "components/ui/SectionTitle";
import { Field, Form, Formik } from "formik";
import { ContactSection, FormErrorMessage } from "./style";
import * as Yup from "yup";
import { CREATE_MESSAGE } from "graphql/queries";
import { useMutation } from "@apollo/client";
import { Alert } from "components/ui/Alerts";
import { useState } from "react";
interface FormMessage {
    name: string;
    email: string;
    message: string;
}

export const ContactForm: React.FC = () => {
    const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false);
    const [formError, setFormError] = useState<string>("");
    const initialValues: FormMessage = {
        name: "",
        email: "",
        message: ""
    };

    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Invalid email")
            .required("Email is required"),
        message: Yup.string().required("Message is required")
    });

    const [createMessage] = useMutation<object, FormMessage>(CREATE_MESSAGE, {
        onCompleted() {
            setShowSuccessAlert(true);
            setFormError("");
        },
        onError(error) {
            setFormError(error.message);
        }
    });

    return (
        <ContactSection id="contact" className="body-section">
            <Container>
                <SectionTitle heading="Let's Talk" subHeading="Contact" />
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={async values => {
                        await createMessage({
                            variables: {
                                email: values.email,
                                name: values.name,
                                message: values.message
                            }
                        });
                    }}
                >
                    {({
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        values,
                        isSubmitting
                    }) => (
                        <Form>
                            {formError && (
                                <FormErrorMessage>{formError}</FormErrorMessage>
                            )}
                            <InputGroup
                                label="Name"
                                name="name"
                                as={Field}
                                placeholder="What should i call you?, you can call me Zack"
                                error={touched.name && errors.name}
                            />
                            <InputGroup
                                name="email"
                                label="Email"
                                as={Field}
                                placeholder="Email to reach you"
                                error={touched.email && errors.email}
                            />
                            <InputGroup
                                label="Message"
                                name="message"
                                as="textarea"
                                value={values.message}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Small description about your requirements"
                                error={touched.message && errors.message}
                            />
                            <Button
                                isLoading={isSubmitting}
                                type="submit"
                                aria-label="submit"
                            >
                                Send
                            </Button>
                        </Form>
                    )}
                </Formik>
            </Container>
            {showSuccessAlert && (
                <Alert
                    title="Thank you for reaching out to me"
                    text="Expect a response within 1-4 days"
                    setShowAlert={setShowSuccessAlert}
                />
            )}
        </ContactSection>
    );
};
